module.exports = __webpack_public_path__ + "static/media/yellowBingoBall.44e0dd71.png";